import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

const COMMITTEE_ROLE = 'COMMITTEE';
const MODERATOR_ROLE = 'MODERATOR';

export const committeeGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const roles = auth.backendRoles;
  const canAccessReviewBoard = roles.some((r) => {
    const code = r.toUpperCase();
    return code === COMMITTEE_ROLE || code === MODERATOR_ROLE || code === 'ADMIN';
  });

  return canAccessReviewBoard ? true : router.createUrlTree(['/feed']);
};

